// FormFields.jsx
import React from 'react';
import { SaveIcon } from 'lucide-react';
import './FormFields.css';
import DynamicForm from '../DynamicForm';
import { LAYOUT_CONFIG } from '../../../api/layoutConfig';

const FormFields = ({ layout, data, onChange, errors, onSave, campaigns }) => {
  const config = LAYOUT_CONFIG[layout];
  if (!config || !config.fields) {
    return <div>No form configuration for this layout.</div>;
  }

  return (
    <div className="form-fields">
      <div className="form-fields-header">
        <h2>Edit Content</h2>
        <button className="save-button" onClick={onSave}>
          <SaveIcon className="mr-1" /> Save
        </button>
      </div>
      <DynamicForm
        schema={config.fields}
        data={data}
        onChange={onChange}
        errors={errors}
        campaigns={campaigns}
      />
    </div>
  );
};

export default FormFields;